import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "helper/global";

const initialState = {
  id: null,
  name: null,
  avatarUrl: null,
  typeId: null,
  departmentId: null,
  loading: false,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.USER_LOAD:
      return updateObject(state, {
        ...action,
        loading: false,
        error: null,
      });
    case actionTypes.USER_UPDATE:
      return updateObject(state, {
        ...action,
        loading: false,
        error: null,
      });
    default:
      return state;
  }
};

export default reducer;


// const initialState = {
//   name: null,
//   avatarUrl: null,
//   theme: null,
//   accessOrganization: null,
//   accessResource: false,
//   loading: false,
//   error: null,
// };

